// This file will contain all the role specific dashboards

import { ErrorBoundary } from "react-error-boundary";
import { AllSectionsProps } from "../Cards/Interfaces/DashboardContainer";
import {
	AccountantTopDashboardContainer,
	AdminTopDashboardContainer,
	CEOTopDashboardContainer,
	ITTopDashboardContainer,
	ManagerTopDashboardContainer,
} from "../Containers/MainDashboardContainer";
import { ProjectTrendsComponent } from "../ProjectTrends/ProjectTrends";
import { AnnouncementSection } from "./AnnouncementSection";
import { SectionErrorFallback } from "./Components/SectionErrorFallback";
import { ContactUsSection } from "./ContactUsSection";
import { HistorySection } from "./HistorySection";

function BoundedSection({
	title,
	children,
}: {
	title: string;
	children: React.ReactNode;
}) {
	return (
		<ErrorBoundary fallback={<SectionErrorFallback title={title} />}>
			{children}
		</ErrorBoundary>
	);
}

export function AdminDashboard(props: AllSectionsProps) {
	return (
		<>
			{props.contactUs.length > 0 && (
				<BoundedSection title="Contact Us">
					<ContactUsSection {...props} />
				</BoundedSection>
			)}

			{props.announcements.length > 0 && (
				<BoundedSection title="Announcements">
					<AnnouncementSection {...props} />
				</BoundedSection>
			)}

			<AdminTopDashboardContainer {...props} />

			<BoundedSection title="Project Trends">
				<ProjectTrendsComponent />
			</BoundedSection>

			<BoundedSection title="History">
				<HistorySection />
			</BoundedSection>
		</>
	);
}

export function CEODashboard(props: AllSectionsProps) {
	return (
		<>
			{props.contactUs.length > 0 && (
				<BoundedSection title="Contact Us">
					<ContactUsSection {...props} />
				</BoundedSection>
			)}

			{props.announcements.length > 0 && (
				<BoundedSection title="Announcements">
					<AnnouncementSection {...props} />
				</BoundedSection>
			)}

			<CEOTopDashboardContainer {...props} />

			<BoundedSection title="Project Trends">
				<ProjectTrendsComponent />
			</BoundedSection>

			<BoundedSection title="History">
				<HistorySection />
			</BoundedSection>
		</>
	);
}

export function ITDashboard(props: AllSectionsProps) {
	return (
		<>
			{props.announcements.length > 0 && (
				<BoundedSection title="Announcements">
					<AnnouncementSection {...props} />
				</BoundedSection>
			)}

			<ITTopDashboardContainer {...props} />

			<BoundedSection title="History">
				<HistorySection />
			</BoundedSection>
		</>
	);
}

export function ManagerDashboard(props: AllSectionsProps) {
	return (
		<>
			{props.announcements.length > 0 && (
				<BoundedSection title="Announcements">
					<AnnouncementSection {...props} />
				</BoundedSection>
			)}

			<ManagerTopDashboardContainer {...props} />

			<BoundedSection title="History">
				<HistorySection />
			</BoundedSection>
		</>
	);
}

export function AccountantDashboard(props: AllSectionsProps) {
	return (
		<>
			{props.announcements.length > 0 && (
				<BoundedSection title="Announcements">
					<AnnouncementSection {...props} />
				</BoundedSection>
			)}

			<AccountantTopDashboardContainer {...props} />

			<BoundedSection title="History">
				<HistorySection />
			</BoundedSection>
		</>
	);
}
